import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AllCategoryContainer = styled.div`
  display: grid;
  padding: 0px 15px;
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }
`

export const AllCategoryHeader = styled.div`
  margin-top: 27px;
  @media screen and (min-width: 1100px) {
    display: grid;
    grid-template-columns: 2fr 9fr;
  }
`

export const TopCategoryContainer = styled.div`
  .slick-slider {
    display: grid;
    max-height: 100%;
    .slick-dots {
      bottom: -25px;
    }
  }

  @media screen and (min-width: 1100px) {
  }
`

export const CategoryText = styled.div`
  margin: 16px 0;

  @media screen and (min-width: 1100px) {
  }
`

export const TopCategorySlide = styled.div`
  display: grid !important;
  grid-template-columns: 1fr 1fr;
  grid-gap: 23px;
`

export const TopCategoryItemCont = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  @media screen and (min-width: 1100px) {
    display: none;
    &.desktop-top-category {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      display: grid;
      grid-column-gap: 29px;
      grid-row-gap: 30px;
    }
  }
`

export const TopCategoryItem = styled(Link)`
  border-radius: 6px;
  background-color: #f2f4f8;
  padding: 28px 32px;
  text-align: center;
  display: grid;
  grid-template-rows: auto auto;
  grid-row-gap: 30px;
  justify-items: center;
  text-decoration: none;

  img {
    max-width: 90px;
  }

  p {
    font-size: ${props => props.theme.font.size.sm};
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
  }
  @media screen and (min-width: 1100px) {
    img {
      max-width: 140px;
    }
  }

  @media screen and (max-width: 400px) {
    padding: 15px 10px;
  }

`

export const PopularProducts = styled.div`
  display: grid;
  margin-top: 23px;
  grid-template-columns: 1fr 1fr;
  grid-gap: 23px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: 29px;
  }
`
